import React from 'react';

import BackBtn from '../../../components/UI/BackBtn';
import { Tab, Tabs } from '../../../components/Tabs';
import { styledTableHeading } from '../../../helpers';
import AdminUnifiedIndexes from './AdminUnifiedIndexes';
import NonUnifiedIndexes from './NonUnifiedIndexes';

const tabs = [
  {
    label: 'unified',
    tabName: 'Унифицированные показатели',
    tabType: 'unified',
    tabHeader: 'Унифицированные показатели',
    content: AdminUnifiedIndexes,
  },

  {
    label: 'non-unified',
    tabName: 'Неунифицированные показатели',
    tabType: 'non-unified',
    tabHeader: 'Неунифицированные показатели',
    content: NonUnifiedIndexes,
  },
];

export default function AdminIndexes() {
  return (
    <section className="page">
      <div style={{ padding: '3em' }}>
        <div style={{ marginBottom: 16 }}>
          <BackBtn />
        </div>
        <h3 style={styledTableHeading}>Реестр показателей проектов</h3>
        <Tabs>
          {tabs.map((tab, i) => (
            <Tab key={i} label={tab.label} tabName={tab.tabName}>
              <tab.content />
            </Tab>
          ))}
        </Tabs>
      </div>
    </section>
  );
}
